<template>
    <div>
        <h5>{{group_name }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="4" />
            </el-aside>
            <el-main>
                <el-tag :key="index" v-for="(tag, index) in tags" closable :disable-transitions="false" @click.native="editTag(tag, index)" @close="handleClose(tag, index)">
                    {{tag.tag_name}}
                </el-tag>
                <template v-if="inputVisible">
                    <el-row type="flex" justify="center">
                        <el-col :span="12">
                            <el-input class="input-new-tag" v-model="input_tag" ref="saveTagInput" size="small" @blur="handleInputConfirm($event)" @keyup.enter.native="$event.target.blur">
                                <template slot="append">
                                    <el-button class="button-new-tag" size="small" @click="handleInputConfirm($event)">添加标签</el-button>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </template>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新 标 签</el-button>
                <el-dialog title="标签修改" :visible.sync="dialogFormVisible">
                    <el-form :model="edit_tag">
                        <el-form-item label="标签名称">
                            <el-input v-model="edit_tag.tag_name" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="edit">修 改</el-button>
                    </div>
                </el-dialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios';
import config from '../config.js'
import SubMenu from './SubMenu.vue'
export default {
    components: {
        SubMenu
    },
    data() {
        return {
            group_id: '',
            group_name: '',
            edit_tag: {
                tag_name: '',
                tag_id: '',
                index: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入对象名称', trigger: 'blur' }
                ]
            },
            tags: [],
            inputVisible: false,
            input_tag: '',
            dialogFormVisible: false
        }
    },
    created() {
        //console.log(this.$route.params.group_id)
        this.group_id = this.$route.params.group_id;
        this.getTags();
        this.getGroup()
    },
    methods: {
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                },
            }).then((response) => {
                let res = response.data
                this.group_id = res.group_id
                this.group_name = res.group_name
            })
        },
        onSubmit() {
            console.log('submit!')
            if (!this.validata()) {
                this.$message({
                    type: 'error',
                    message: '请填写正确的手机号'
                })
            }
        },
        validata() {
            let phone_num = this.phone_num
            if (!((/^1[34578]\d{9}$/).test(phone_num))) {
                return false
            }
            return true
        },
        getTags() {
            //console.log('getTags')
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                },
            }).then((response) => {
                this.tags = response.data
            })
        },
        handleClose(tag, index) {
            this.$confirm('此操作将删除该标签, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios({
                    method: 'delete',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_duixiang_tags/' + tag.tag_id
                }).then((response) => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.tags.splice(index, 1);
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm(e) {
            //console.log(e)

            let _this = this
            //console.log(this.input_tag)
            axios({
                    method: 'post',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group_id,
                    data: {
                        tag_name: this.input_tag
                    }
                })
                .then(function(response) {
                    //console.log(response)
                    _this.tags.push(response.data)
                    _this.input_tag = ''
                    _this.$message({
                        message: '标签新增成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
            this.inputVisible = false
        },
        editTag(tag, index) {
            //console.log(tag)
            this.edit_tag.tag_name = tag.tag_name
            this.dialogFormVisible = true
            this.edit_tag.tag_name = tag.tag_name
            this.edit_tag.tag_id = tag.tag_id
            this.edit_tag.index = index

        },
        edit() {
            //console.log('edi')
            let data = { tag_name: this.edit_tag.tag_name }
            let url = '/yun_table/yun_duixiang_tags/' + this.edit_tag.tag_id + '?group_id=' + this.group_id
            axios({
                    method: 'put',
                    url: config.base_url + url,
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    data: data
                })
                .then((response) => {
                    this.input_tag = ''
                    this.$message({
                        message: '标签修改成功',
                        type: 'success'
                    })
                    this.tags[this.edit_tag.index]['tag_name'] = data.tag_name
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
            this.dialogFormVisible = false
        },


    }

}
</script>
<style>
.el-tag {
    margin-bottom: 10px;
    margin-right: 10px;
    cursor: pointer;
}

/*.el-tag + .el-tag {
    margin-left: 10px;
  }*/
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>